export default {
  getInstitutesOfAUser: '/instituteUser/getInstituteUsers',
  getNameOfInstitute: '/institute/getNameOfInstitute'
}
